module.exports = __webpack_public_path__ + "img/11087922_L.8ca3a4f1.png";